import { Languages } from "lucide-react";

const SLUG = "prismes-foi-doute";
const VERSIONS = [
  { lang: "fr", label: "Français (original)", src: `/derive/${SLUG}.mp3` },
  { lang: "en", label: "English (IA)", src: `/derive/dub/${SLUG}-en.mp3` },
  { lang: "es", label: "Español (IA)", src: `/derive/dub/${SLUG}-es.mp3` },
  { lang: "nl", label: "Nederlands (IA)", src: `/derive/dub/${SLUG}-nl.mp3` },
];

export function DubTrialAdmin() {
  return (
    <div className="mb-8 rounded-2xl border border-white/10 bg-white/[0.03] p-5" data-testid="admin-dub-trial">
      <div className="flex items-center gap-3 mb-1">
        <Languages size={16} className="text-primary" />
        <h3 className="font-display text-xl">Essai de doublage · N°61 « Les prismes de la foi et du doute »</h3>
      </div>
      <p className="text-sm text-foreground/55 mb-4">Voix IA : Patrick (voix grave) et l'animateur (voix plus jeune). Écoute et dis-moi si l'on double les autres épisodes.</p>
      <div className="grid sm:grid-cols-2 gap-3">
        {VERSIONS.map((v) => (
          <div key={v.lang} className="rounded-xl bg-background/50 border border-white/5 p-3">
            <p className="text-xs text-foreground/60 mb-2">{v.label}</p>
            <audio controls preload="none" src={v.src} className="w-full h-9" data-testid={`admin-dub-audio-${v.lang}`} />
          </div>
        ))}
      </div>
    </div>
  );
}
